import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-catalogs-new-catalog-dashboard',
  templateUrl: './catalogs-new-catalog-dashboard.component.html',
  styleUrls: ['./catalogs-new-catalog-dashboard.component.scss']
})
export class CatalogsNewCatalogDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-book', 'catalogs-page.new catalog', '/catalog/catalogs', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.catalogs', '/catalog/catalogs'), new BRoute('catalogs-page.new catalog')]));
  }
}
